import { connect } from "react-redux";
import { Dispatch } from "react";
import BannerPage from "components/pages/banner/BannerPage";
import actions from "redux/actions/Index";
import { RootState } from "redux/reducers/RootReducer";
import {
  IBannerProductsResponse,
  IUpdateBannerPayload,
} from "../interfaces/banner.interface";

export const mapStateToProps = (state: RootState) => {
  const { banner, zone } = state;
  return {
    isLoading: banner.isLoading,
    isError: banner.isError,
    error: banner.error,
    banner: banner.banner,
    isBannerFetched: banner.isBannerFetched,
    isBannerProductsFetched: banner.isBannerProductsFetched,
    isBannerAndProductsUpdated: banner.isBannerAndProductsUpdated,
    isBannerSequenceUpdated: banner.isBannerSequenceUpdated,
    cityList: zone.citiesList,
    retainedCity: zone.retainedCity,
    customerConfig: state.customer?.customerConfig,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCities: () => dispatch(actions.fetchCities()),
    fetchCustomerChannelAction: () => dispatch(actions.fetchCustomerConfig()),
    getBanners: (cityId: string, customerChannel: string) =>
      dispatch(actions.getBanners(cityId, customerChannel)),
    updateBanner: (bannerPayload: IUpdateBannerPayload) =>
      dispatch(actions.updateBanner(bannerPayload)),
    uploadImageAndUpdateBannerWithProducts: (
      imgPayload: FormData,
      desktopImgPayload: FormData,
      bannerPayload: IUpdateBannerPayload,
      bannerProductsPayload: any
    ) =>
      dispatch(
        actions.uploadImageAndUpdateBannerAndProducts(
          imgPayload,
          desktopImgPayload,
          bannerPayload,
          bannerProductsPayload
        )
      ),
    updateBannerWithProducts: (
      bannerPayload: IUpdateBannerPayload,
      bannerProductsPayload: IBannerProductsResponse[]
    ) =>
      dispatch(
        actions.updateBannerAndProducts(bannerPayload, bannerProductsPayload)
      ),
    uploadBannerImageAction: (
      imgPayload: FormData,
      desktopImagePayload: FormData
    ) =>
      dispatch(
        actions.uploadBannerImageAction(imgPayload, desktopImagePayload)
      ),
    updateBannerSequence: (cityId: string, bannerIds: string[]) =>
      dispatch(actions.updateBannerSequence(cityId, bannerIds)),
  };
};

const BannersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(BannerPage);

export default BannersContainer;
